import { deleteCoreDataDictionaryViewsAsyncSlice } from './delete';
import { getCoreDataDictionaryViewsAsyncSlice } from './get';
import { patchCoreDataDictionaryViewsAsyncSlice } from './patch';
import { postCoreDataDictionaryViewAsyncSlice } from './post';
import { updateCoreDataDictionaryViewsSyncSlice } from './update';

export const { requestDeleteCoreDataDictionaryViews, resetDeleteCoreDataDictionaryViews } =
	deleteCoreDataDictionaryViewsAsyncSlice.asyncActionCreators;

export const { requestGetCoreDataDictionaryViews, resetGetCoreDataDictionaryViews } =
	getCoreDataDictionaryViewsAsyncSlice.asyncActionCreators;

export const { requestPatchCoreDataDictionaryViews, resetPatchCoreDataDictionaryViews } =
	patchCoreDataDictionaryViewsAsyncSlice.asyncActionCreators;

export const { requestPostCoreDataDictionaryViews, resetPostCoreDataDictionaryViews } =
	postCoreDataDictionaryViewAsyncSlice.asyncActionCreators;

export const updateCoreDataDictionaryView = updateCoreDataDictionaryViewsSyncSlice.syncActionCreator;

export * from './references/actions';
export * from './shared-key/actions';
